/* eslint-disable @typescript-eslint/naming-convention */

import { IFormItemProps } from '@/components';
import { NovelHomeItemType } from '@/interface/novel';

export const NovelHomeTypeOptions = [
  { label: '多榜单', value: NovelHomeItemType.HOMEDATAITEMTYPE_MULTICOLLECTION }, // 单个故事
];

export const formMultiCollection: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'type',
    label: '配置类型',
    render: 'select',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      options: NovelHomeTypeOptions,
    },
  },
  {
    props: 'multiCollection',
    label: '榜单配置',
    render: 'customNovelMultiCollection',
  },
];


export const formConfig: { [key: string]: IFormItemProps[] } = {
  [NovelHomeItemType.HOMEDATAITEMTYPE_MULTICOLLECTION]:
    formMultiCollection,
};


